export default __webpack_public_path__ + "static/media/user.b5f0b433.png";